import type { ConstValues } from '@openx/types/helpers.ts';
import { CHECKBOX_COLUMN } from '../../shared/utils/consts.ts';
import { getTableMinWidth } from '../../shared/utils/styles.ts';
import type { OpenXAgentTableColumn } from '../../shared/utils/types.ts';
import type { SortAccessors } from '../../shared/utils/useSorting.ts';
import type { OpenXAgentMatchedDomainApp } from './types.ts';

export const DealType = {
  DIRECT: 'direct',
  OPEN_MARKET: 'openMarket',
} as const;

export type DealType = ConstValues<typeof DealType>;

const NAME_COLUMN_MIN_WIDTH = 200;

export const TABLE_COLUMNS: OpenXAgentTableColumn[] = [
  CHECKBOX_COLUMN,
  { id: 'name', width: 'auto' },
  { id: 'spend', width: '124px' },
  { id: 'marketRequest', width: '160px' },
  { id: 'relevance', width: '124px' },
];

export const TABLE_MIN_WIDTH = getTableMinWidth(TABLE_COLUMNS, NAME_COLUMN_MIN_WIDTH);

export const SORT_ACCESSORS: SortAccessors<OpenXAgentMatchedDomainApp> = {
  name: ({ name }) => name,
  spend: ({ spend }) => spend,
  marketRequest: ({ marketRequest }) => marketRequest,
  relevance: ({ relevance }) => relevance,
};
